import {Cart, CartItem} from "./services/cart-service";

export class Image {
  id:           number;
  created_at:   Date;
  updated_at:   Date;
  content_type: string;
  file_name:    string;
  name:         string;
  url:          string;
  position:     number;
  height:       number;
  width:        number;

  constructor (data:any) {
    this.id           = data.id;
    this.created_at   = new Date(data.created_at);
    this.updated_at   = new Date(data.updated_at);
    this.content_type = data.content_type;
    this.file_name    = data.file_name;
    this.name         = data.name;
    this.url          = data.url;
    this.position     = data.position;
    this.height       = data.height;
    this.width        = data.width;
  }
}

export class Category {
  id:          number;
  created_at:  Date;
  updated_at:  Date;
  name:        string;
  description: string;
  image!:       Image;

  constructor (data:any) {
    this.id           = data.id;
    this.created_at   = new Date(data.created_at);
    this.updated_at   = new Date(data.updated_at);
    this.name         = data.name;
    this.description  = data.description;

    if (data.image) {
      this.image = new Image(data.image);
    }
  }
}


export class Collection {
  id:          number;
  created_at:  Date;
  updated_at:  Date;
  name:        string;
  description: string;
  image!:      Image;

  constructor (data:any) {
    this.id           = data.id;
    this.created_at   = new Date(data.created_at);
    this.updated_at   = new Date(data.updated_at);
    this.name         = data.name;
    this.description  = data.description;

    if (data.image) {
      this.image = new Image(data.image);
    }
  }
}

export class Item {
  id:          number;
  created_at:  Date;
  updated_at:  Date;
  name:        string;
  description: string;
  price:       number;
  images:      Image[];

  constructor (data:any) {
    this.id           = data.id;
    this.created_at   = new Date(data.created_at);
    this.updated_at   = new Date(data.updated_at);
    this.name         = data.name;
    this.description  = data.description;
    this.price        = data.price;

    this.images = [];
    if (data.images) {
      for (let img of data.images) {
        this.images.push(new Image(img))
      }

      //sort
      this.images =  this.images.sort((a,b) => a.position < b.position? -1 : 1);
    }
  }

  getImageKey():string {
    if (this.images && this.images.length > 0) {
      return this.images[0].file_name;
    }
    return '';
  }

  getFirstImage():Image|null {
    if (this.images && this.images.length > 0) {
      return this.images[0];
    }
    return null;
  }
}

export class OrderedItem {
  item:     Item;
  ordinal:  number;

  constructor (data:any) {
    this.item    = new Item(data.item);
    this.ordinal = data.ordinal;
  }
}

export class Address {
  first_name: string = "";
  last_name: string = "";
  gender: string = "";
  street: string = "";
  e_mail: string = "";
  city: string = "";
  zip: string = "";
  country: string = "Deutschland";
}

export class Order {
  amount: number;
  shipping_address: Address;
  invoice_address: Address;
  hasInvoiceAddress:boolean;
  items: OrderItem[];
  remark: string;

  constructor (cart:Cart) {
    this.amount = cart.getTotalAmount();
    this.shipping_address = new Address();
    this.invoice_address = new Address();
    this.hasInvoiceAddress = false;
    this.remark = cart.remark;
    this.items = [];
    for (let ci of cart.items) {
      this.items.push(new OrderItem(ci));
    }
  }
}

export class OrderItem {
  item: Item;
  quantity: number;
  price: number;

  constructor (ci: CartItem) {
    this.item =  ci.item;
    this.quantity = parseInt(ci.quantity + '');
    this.price = ci.item.price;
  }
}